import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Alert_Interface, Empty_Alert_Interface } from 'src/app/Interface/Alert_Interface';
import { AlertService } from 'src/app/Service/Alert/Alert.service';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-AlertList',
  templateUrl: './AlertList.component.html',
  styleUrls: ['./AlertList.component.css']
})
export class AlertListComponent implements OnInit {

  Token: string = ""
  page: number = 0;
  Procssing: boolean = false

  Filter_title:string=""
  Filter_username: string = ""
  Filter_dsc: string = ""

  constructor(
    private Nav_Service: NavService,
    private Alert_Service: AlertService,
    private Alertify_Service: AlertifyService,
    public router: Router,
    private modalService: BsModalService
  ) { }

  DataList_Alert: Array<Alert_Interface> = []
  Data_Seleted_Alert: Alert_Interface = Empty_Alert_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token, 1144).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  StartDate:string=""
  EndDate:string=""

  ReadData_Alert(StartSearchDate, EndSearchDate) {
    this.StartDate=StartSearchDate
    this.EndDate = EndSearchDate

    this.Procssing = true
    this.Alert_Service.GetRecord(this.Token,StartSearchDate,EndSearchDate).subscribe(
      data => {
        this.DataList_Alert = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  View_Form_Switcher:String='List'

  set_Alert_New(){
    this.Data_Seleted_Alert = Empty_Alert_Interface()
    this.View_Form_Switcher='Form'
  }

  set_Alert_Record(item: Alert_Interface) {
    this.Data_Seleted_Alert = item
    this.View_Form_Switcher='Form'
  }

  back_AlertList() {
    this.Data_Seleted_Alert = Empty_Alert_Interface()
    this.View_Form_Switcher='List'
  }

  modalRef_Delete: any
  Delete(item: Alert_Interface) {
    this.Procssing = true
    this.modalRef_Delete.hide()
    this.Alert_Service.DeleteAlert(item.id, this.Token).subscribe(
      data => {
        this.Procssing = false
        this.Alertify_Service.SuccessMessage("Deleted successfully")
        this.ReadData_Alert(this.StartDate,this.EndDate)
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Alert = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  Change_Filter_title(){
    this.page=0
  }


  modalRef_Alert: any
  on_Set_View(item: Alert_Interface,template: TemplateRef<any>)
  {
    this.modalRef_Alert = this.modalService.show(template);
    this.Data_Seleted_Alert=item
  }


}
